import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormPageCard, FormPageCardProps } from '../FormPageCard';

export interface EntityPageCardProps extends FormPageCardProps {}

export function _EntityPageCard(props: EntityPageCardProps) {
  return <FormPageCard {...props} />;
}

_EntityPageCard.displayName = 'EntityPageCard';

export const EntityPageCard = observer(_EntityPageCard);
